module.exports = __webpack_public_path__ + "static/media/Convertible.ed8a6c15.svg";